export default {
    "ADD": "ADD",
    "SAVE": "ADD",
    "EDIT": "EDIT",
    "VIEW": "VIEW",
    "DELETE": "DELETE",
    "UNLOCK": "LOCK",
    "LOCK": "LOCK",
    "DELETE_BATCH": "DELETE",
    "STATISTICS": "STATISTICS",
    "HISTORY": "EDIT",
    "COPY": "COPY",
    "ACTIVATE": "ACTIVATE",
    "EXPORT":"EXPORT",
    "DEACTIVATE": "ACTIVATE"
}